<form (ngSubmit)="addValue(newValue.value); newValue.value = ''">
  <div class="row narrow-gutters">
    @for (v of values; track v) {
      <div class="col-auto my-2 values">
        <span class="w-100 d-flex badge text-bg-secondary fw-normal">
          <span class="text-truncate d-flex align-items-center">
            @if (itemTemplate) {
              <ng-container
                [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'item' : v}">
              </ng-container>
            } @else {
              {{ formatter(v) }}
            }
          </span>
          <button type="button" (click)="deleteValue(v)" [disabled]="readonly" class="btn-close ms-2"></button>
        </span>
      </div>
    }
    <div class="col my-2 input-wrapper" style="min-width: 8rem">
      <input #newValue [placeholder]="placeholder || 'Add value'" class="w-100 border-secondary text-dark"
             style="border-width: 0 0 1px 0; line-height: 1.5rem; outline: 0" [required]="required && values.length==0"
             [readonly]="readonly"
             (input)="onInput.emit(newValue.value)"
             (blur)="addValue($event.target.value); $event.target.value = ''">
    </div>
  </div>
</form>
